/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import {
  AggregateIssueState,
  aggregateIssueStateFromJSON,
  aggregateIssueStateToJSON,
  aggregateIssueStateToNumber,
} from "../../issues/v1/issues";

export const protobufPackage = "protos.ai.v1";

export interface AiPatch {
  id: number;
  status: AiPatch_Status;
  type: AiPatch_Type;
  title: string;
  link: string;
  description: string;
  project: string;
  state: AggregateIssueState;
}

export enum AiPatch_Type {
  UNSPECIFIED = "TYPE_UNSPECIFIED",
  RULE_DEFINITION = "TYPE_RULE_DEFINITION",
  DISABLE_RULE = "TYPE_DISABLE_RULE",
  CODE_FIX = "TYPE_CODE_FIX",
  SCA_UPGRADE = "TYPE_SCA_UPGRADE",
  SECRETS_REVOKE = "TYPE_SECRETS_REVOKE",
}

export function aiPatch_TypeFromJSON(object: any): AiPatch_Type {
  switch (object) {
    case 0:
    case "TYPE_UNSPECIFIED":
      return AiPatch_Type.UNSPECIFIED;
    case 1:
    case "TYPE_RULE_DEFINITION":
      return AiPatch_Type.RULE_DEFINITION;
    case 2:
    case "TYPE_DISABLE_RULE":
      return AiPatch_Type.DISABLE_RULE;
    case 3:
    case "TYPE_CODE_FIX":
      return AiPatch_Type.CODE_FIX;
    case 4:
    case "TYPE_SCA_UPGRADE":
      return AiPatch_Type.SCA_UPGRADE;
    case 5:
    case "TYPE_SECRETS_REVOKE":
      return AiPatch_Type.SECRETS_REVOKE;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum AiPatch_Type");
  }
}

export function aiPatch_TypeToJSON(object: AiPatch_Type): string {
  switch (object) {
    case AiPatch_Type.UNSPECIFIED:
      return "TYPE_UNSPECIFIED";
    case AiPatch_Type.RULE_DEFINITION:
      return "TYPE_RULE_DEFINITION";
    case AiPatch_Type.DISABLE_RULE:
      return "TYPE_DISABLE_RULE";
    case AiPatch_Type.CODE_FIX:
      return "TYPE_CODE_FIX";
    case AiPatch_Type.SCA_UPGRADE:
      return "TYPE_SCA_UPGRADE";
    case AiPatch_Type.SECRETS_REVOKE:
      return "TYPE_SECRETS_REVOKE";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum AiPatch_Type");
  }
}

export function aiPatch_TypeToNumber(object: AiPatch_Type): number {
  switch (object) {
    case AiPatch_Type.UNSPECIFIED:
      return 0;
    case AiPatch_Type.RULE_DEFINITION:
      return 1;
    case AiPatch_Type.DISABLE_RULE:
      return 2;
    case AiPatch_Type.CODE_FIX:
      return 3;
    case AiPatch_Type.SCA_UPGRADE:
      return 4;
    case AiPatch_Type.SECRETS_REVOKE:
      return 5;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum AiPatch_Type");
  }
}

export enum AiPatch_Status {
  UNSPECIFIED = "STATUS_UNSPECIFIED",
  NEW = "STATUS_NEW",
  ACCEPTED = "STATUS_ACCEPTED",
  REJECTED = "STATUS_REJECTED",
  EXPIRED = "STATUS_EXPIRED",
}

export function aiPatch_StatusFromJSON(object: any): AiPatch_Status {
  switch (object) {
    case 0:
    case "STATUS_UNSPECIFIED":
      return AiPatch_Status.UNSPECIFIED;
    case 10:
    case "STATUS_NEW":
      return AiPatch_Status.NEW;
    case 20:
    case "STATUS_ACCEPTED":
      return AiPatch_Status.ACCEPTED;
    case 30:
    case "STATUS_REJECTED":
      return AiPatch_Status.REJECTED;
    case 40:
    case "STATUS_EXPIRED":
      return AiPatch_Status.EXPIRED;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum AiPatch_Status");
  }
}

export function aiPatch_StatusToJSON(object: AiPatch_Status): string {
  switch (object) {
    case AiPatch_Status.UNSPECIFIED:
      return "STATUS_UNSPECIFIED";
    case AiPatch_Status.NEW:
      return "STATUS_NEW";
    case AiPatch_Status.ACCEPTED:
      return "STATUS_ACCEPTED";
    case AiPatch_Status.REJECTED:
      return "STATUS_REJECTED";
    case AiPatch_Status.EXPIRED:
      return "STATUS_EXPIRED";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum AiPatch_Status");
  }
}

export function aiPatch_StatusToNumber(object: AiPatch_Status): number {
  switch (object) {
    case AiPatch_Status.UNSPECIFIED:
      return 0;
    case AiPatch_Status.NEW:
      return 10;
    case AiPatch_Status.ACCEPTED:
      return 20;
    case AiPatch_Status.REJECTED:
      return 30;
    case AiPatch_Status.EXPIRED:
      return 40;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum AiPatch_Status");
  }
}

export interface GetAiPatchesResponse {
  aiPatches: AiPatch[];
}

export interface PutAiPatchStatusRequest {
  /** experimental idea: validate the status the user had visible is still correct */
  fromStatus: AiPatch_Status;
  toStatus: AiPatch_Status;
}

export interface PutAiPatchStatusResponse {
  newAiPatch: AiPatch | undefined;
}

function createBaseAiPatch(): AiPatch {
  return {
    id: 0,
    status: AiPatch_Status.UNSPECIFIED,
    type: AiPatch_Type.UNSPECIFIED,
    title: "",
    link: "",
    description: "",
    project: "",
    state: AggregateIssueState.UNSPECIFIED,
  };
}

export const AiPatch = {
  encode(message: AiPatch, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== 0) {
      writer.uint32(8).uint64(message.id);
    }
    if (message.status !== AiPatch_Status.UNSPECIFIED) {
      writer.uint32(16).int32(aiPatch_StatusToNumber(message.status));
    }
    if (message.type !== AiPatch_Type.UNSPECIFIED) {
      writer.uint32(24).int32(aiPatch_TypeToNumber(message.type));
    }
    if (message.title !== "") {
      writer.uint32(34).string(message.title);
    }
    if (message.link !== "") {
      writer.uint32(42).string(message.link);
    }
    if (message.description !== "") {
      writer.uint32(50).string(message.description);
    }
    if (message.project !== "") {
      writer.uint32(58).string(message.project);
    }
    if (message.state !== AggregateIssueState.UNSPECIFIED) {
      writer.uint32(64).int32(aggregateIssueStateToNumber(message.state));
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AiPatch {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAiPatch();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.uint64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.status = aiPatch_StatusFromJSON(reader.int32());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.type = aiPatch_TypeFromJSON(reader.int32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.title = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.link = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.description = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.project = reader.string();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.state = aggregateIssueStateFromJSON(reader.int32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AiPatch {
    return {
      id: isSet(object.id) ? Number(object.id) : 0,
      status: isSet(object.status) ? aiPatch_StatusFromJSON(object.status) : AiPatch_Status.UNSPECIFIED,
      type: isSet(object.type) ? aiPatch_TypeFromJSON(object.type) : AiPatch_Type.UNSPECIFIED,
      title: isSet(object.title) ? String(object.title) : "",
      link: isSet(object.link) ? String(object.link) : "",
      description: isSet(object.description) ? String(object.description) : "",
      project: isSet(object.project) ? String(object.project) : "",
      state: isSet(object.state) ? aggregateIssueStateFromJSON(object.state) : AggregateIssueState.UNSPECIFIED,
    };
  },

  toJSON(message: AiPatch): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.status !== AiPatch_Status.UNSPECIFIED) {
      obj.status = aiPatch_StatusToJSON(message.status);
    }
    if (message.type !== AiPatch_Type.UNSPECIFIED) {
      obj.type = aiPatch_TypeToJSON(message.type);
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.link !== "") {
      obj.link = message.link;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.project !== "") {
      obj.project = message.project;
    }
    if (message.state !== AggregateIssueState.UNSPECIFIED) {
      obj.state = aggregateIssueStateToJSON(message.state);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AiPatch>, I>>(base?: I): AiPatch {
    return AiPatch.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AiPatch>, I>>(object: I): AiPatch {
    const message = createBaseAiPatch();
    message.id = object.id ?? 0;
    message.status = object.status ?? AiPatch_Status.UNSPECIFIED;
    message.type = object.type ?? AiPatch_Type.UNSPECIFIED;
    message.title = object.title ?? "";
    message.link = object.link ?? "";
    message.description = object.description ?? "";
    message.project = object.project ?? "";
    message.state = object.state ?? AggregateIssueState.UNSPECIFIED;
    return message;
  },
};

function createBaseGetAiPatchesResponse(): GetAiPatchesResponse {
  return { aiPatches: [] };
}

export const GetAiPatchesResponse = {
  encode(message: GetAiPatchesResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.aiPatches) {
      AiPatch.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetAiPatchesResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAiPatchesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.aiPatches.push(AiPatch.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAiPatchesResponse {
    return { aiPatches: Array.isArray(object?.aiPatches) ? object.aiPatches.map((e: any) => AiPatch.fromJSON(e)) : [] };
  },

  toJSON(message: GetAiPatchesResponse): unknown {
    const obj: any = {};
    if (message.aiPatches?.length) {
      obj.aiPatches = message.aiPatches.map((e) => AiPatch.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAiPatchesResponse>, I>>(base?: I): GetAiPatchesResponse {
    return GetAiPatchesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAiPatchesResponse>, I>>(object: I): GetAiPatchesResponse {
    const message = createBaseGetAiPatchesResponse();
    message.aiPatches = object.aiPatches?.map((e) => AiPatch.fromPartial(e)) || [];
    return message;
  },
};

function createBasePutAiPatchStatusRequest(): PutAiPatchStatusRequest {
  return { fromStatus: AiPatch_Status.UNSPECIFIED, toStatus: AiPatch_Status.UNSPECIFIED };
}

export const PutAiPatchStatusRequest = {
  encode(message: PutAiPatchStatusRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.fromStatus !== AiPatch_Status.UNSPECIFIED) {
      writer.uint32(8).int32(aiPatch_StatusToNumber(message.fromStatus));
    }
    if (message.toStatus !== AiPatch_Status.UNSPECIFIED) {
      writer.uint32(16).int32(aiPatch_StatusToNumber(message.toStatus));
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PutAiPatchStatusRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePutAiPatchStatusRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.fromStatus = aiPatch_StatusFromJSON(reader.int32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.toStatus = aiPatch_StatusFromJSON(reader.int32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PutAiPatchStatusRequest {
    return {
      fromStatus: isSet(object.fromStatus) ? aiPatch_StatusFromJSON(object.fromStatus) : AiPatch_Status.UNSPECIFIED,
      toStatus: isSet(object.toStatus) ? aiPatch_StatusFromJSON(object.toStatus) : AiPatch_Status.UNSPECIFIED,
    };
  },

  toJSON(message: PutAiPatchStatusRequest): unknown {
    const obj: any = {};
    if (message.fromStatus !== AiPatch_Status.UNSPECIFIED) {
      obj.fromStatus = aiPatch_StatusToJSON(message.fromStatus);
    }
    if (message.toStatus !== AiPatch_Status.UNSPECIFIED) {
      obj.toStatus = aiPatch_StatusToJSON(message.toStatus);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PutAiPatchStatusRequest>, I>>(base?: I): PutAiPatchStatusRequest {
    return PutAiPatchStatusRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PutAiPatchStatusRequest>, I>>(object: I): PutAiPatchStatusRequest {
    const message = createBasePutAiPatchStatusRequest();
    message.fromStatus = object.fromStatus ?? AiPatch_Status.UNSPECIFIED;
    message.toStatus = object.toStatus ?? AiPatch_Status.UNSPECIFIED;
    return message;
  },
};

function createBasePutAiPatchStatusResponse(): PutAiPatchStatusResponse {
  return { newAiPatch: undefined };
}

export const PutAiPatchStatusResponse = {
  encode(message: PutAiPatchStatusResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.newAiPatch !== undefined) {
      AiPatch.encode(message.newAiPatch, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PutAiPatchStatusResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePutAiPatchStatusResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.newAiPatch = AiPatch.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PutAiPatchStatusResponse {
    return { newAiPatch: isSet(object.newAiPatch) ? AiPatch.fromJSON(object.newAiPatch) : undefined };
  },

  toJSON(message: PutAiPatchStatusResponse): unknown {
    const obj: any = {};
    if (message.newAiPatch !== undefined) {
      obj.newAiPatch = AiPatch.toJSON(message.newAiPatch);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PutAiPatchStatusResponse>, I>>(base?: I): PutAiPatchStatusResponse {
    return PutAiPatchStatusResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PutAiPatchStatusResponse>, I>>(object: I): PutAiPatchStatusResponse {
    const message = createBasePutAiPatchStatusResponse();
    message.newAiPatch = (object.newAiPatch !== undefined && object.newAiPatch !== null)
      ? AiPatch.fromPartial(object.newAiPatch)
      : undefined;
    return message;
  },
};

declare const self: any | undefined;
declare const window: any | undefined;
declare const global: any | undefined;
const tsProtoGlobalThis: any = (() => {
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }
  if (typeof self !== "undefined") {
    return self;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof global !== "undefined") {
    return global;
  }
  throw "Unable to locate global object";
})();

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(Number.MAX_SAFE_INTEGER)) {
    throw new tsProtoGlobalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
